import e from "react";

function t(t) {
  void 0 === t && (t = null);
  var r = e.useState(t),
      n = r[0],
      u = r[1],
      c = e.useRef({
    current: n
  }).current;
  return Object.defineProperty(c, "current", {
    get: function get() {
      return n;
    },
    set: function set(e) {
      Object.is(n, e) || (n = e, u(e));
    }
  }), c;
}

export default t;